<template>

    <el-tabs @tab-click="handleClick" type="card" v-model="activeName">
        <el-tab-pane :label="serviceType" :name="'position'+index" v-bind:key="index" v-for="(serviceType,index) in serviceTypes">
            <goods-list :businessId="businessId" :type="serviceType"></goods-list>
        </el-tab-pane>

    </el-tabs>

</template>

<script>
import GoodsList from './children/GoodsList'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  name: 'plusGoods-tab-index',
  data () {
    return {
      businessId: null,
      isAdmin: false,
      activeName: 'position0',
      serviceTypes: []
    }
  },
  created: function () {
    let params = this.$route.params

    this.businessId = params.businessId
    this.selectBusinessDetail()
  },
  activated: function () {
    let params = this.$route.params
    if (params.businessId !== this.businessId) {
      this.activeName = 'position0'
    }
    this.businessId = params.businessId
    this.selectBusinessDetail()
  },
  mounted: function () {
  },
  components: {
    GoodsList
  },
  methods: {
    selectBusinessDetail: function () {
      let _this = this
      let params = { id: this.businessId }
      let listener = {
        success: function (dataInfo) {
          let serviceType = dataInfo.datas.serviceType
          _this.serviceTypes = serviceType.split(',')
        }
      }
      BasicModel.get(_this, 'lcwpbusiness/selectBusinessInfo.action', params, listener)
    }
  }
}
</script>
